module.exports = __webpack_public_path__ + "img/ex9.99d0e4b6.png";